module.exports = __webpack_public_path__ + "static/texteditor-8936847ec3d6d332341fdc9ed100742a.png";